import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { AdminService } from './admin.service';
import { OrganizationService } from './organization.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  isUser: boolean = false;
  isOrg: boolean = false;
  isAdmin: boolean = false;
  private app = getApp();
  private auth = getAuth(this.app);
  constructor(
    private afAuth: AngularFireAuth, // Inject Firebase auth service
    private userService: UserService,
    private orgService: OrganizationService,
    private adminService: AdminService
  ) {

    this.CheckPrivileges();
  }

  signedIn = false;
  // Sign in with email/password
  SignIn(email: string, password: string) {
    return this.afAuth
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        window.alert(error.message);
      });
  }
  SignOut() {
    return this.afAuth.signOut()
  }

  CheckPrivileges() {
    const user = this.auth.currentUser
    if (user == null) {

    } else {
      const email = user.email;

      if (email == null) {

      } else {
        this.adminService.checkIfAdmin(email);
        this.userService.checkIfUser(email);
        this.orgService.checkIfOrg(email);

        this.isUser = this.userService.isUser;
        this.isAdmin = this.adminService.isAdmin;
        this.isOrg = this.orgService.isOrg;

      }

    }
  }


  checkIfSignedIn() {
    return this.signedIn;
  }
  setSignedIn(signedIn: boolean) {
    this.signedIn = signedIn;
  }
}
